import { useFormikContext } from "formik";
import { Layer } from "../../../../types/Layer";
import { Form } from "react-bootstrap";
import { LicenceTypeUpdateRequest } from "../../../../types/Licences/LicenceTypeUpdateRequest";
import { useEffect, useRef, useState } from "react";

interface LayerCheckboxesProps {
  layers: Layer[];
  visible?: boolean;
}

const LayerCheckboxes = ({ layers, visible = true }: LayerCheckboxesProps) => {
  const { values, setValues } = useFormikContext<LicenceTypeUpdateRequest>();

  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (ref.current === null) {
      return;
    }
    setHeight(ref.current.clientHeight);
  }, []);

  return (
    <>
      {visible || height === 0 ? (
        <div ref={ref} className="mt-2 card p-2">
          {layers.map((lts, index) => {
            return (
              <Form.Group key={index}>
                <Form.Check
                  label={lts.name}
                  type="checkbox"
                  checked={values.accessibleLayerIds?.includes(lts.id)}
                  onChange={() => {
                    const accessibleLayerIds = values.accessibleLayerIds ?? [];
                    const layerId = lts.id;
                    if (accessibleLayerIds.includes(layerId)) {
                      const index = accessibleLayerIds.indexOf(layerId);
                      accessibleLayerIds.splice(index, 1);
                    } else {
                      accessibleLayerIds.push(layerId);
                    }
                    setValues({
                      ...values,
                      accessibleLayerIds,
                    });
                  }}
                  name={`accessibleLayerIds[${index}]`}
                />
              </Form.Group>
            );
          })}
          <Form.Group>
            <Form.Check
              label="Tom Tom Access"
              type="checkbox"
              checked={values.hasTomTomAccess}
              onChange={(e) => {
                setValues({
                  ...values,
                  hasTomTomAccess: e.target.checked,
                });
              }}
              name={`hasTomTomAccess`}
            />
          </Form.Group>
        </div>
      ) : (
        <div style={{ height: height }}></div>
      )}
    </>
  );
};

export default LayerCheckboxes;
